import { render, staticRenderFns } from "./SectionCopyModal.vue?vue&type=template&id=4d5d6124&scoped=true"
import script from "./SectionCopyModal.vue?vue&type=script&lang=js"
export * from "./SectionCopyModal.vue?vue&type=script&lang=js"
import style0 from "./SectionCopyModal.vue?vue&type=style&index=0&id=4d5d6124&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d6124",
  null
  
)

export default component.exports